import { CommonWork } from '../CommonWork'
import { List } from '../List'
import { ContestBody } from './ContestBody'

export class GrantParent extends List {
  constructor(obj) {
    super(Grant, obj)
  }
}

export class GrantBody extends ContestBody {}

export class Grant {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.grantBody = new GrantBody(obj?.grantBody || null)
    this.fromDate = obj?.fromDate || null
    this.toDate = obj?.toDate || null
    this.universityInvolvment = obj?.universityInvolvment || false
    this.link = obj?.link || null
    this.note = obj?.note || null
    this.executor = obj?.executor || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      grantBody: this.grantBody.getForAPI(),
      fromDate: this.fromDate,
      toDate: this.toDate,
      universityInvolvment: this.universityInvolvment,
      link: this.link,
      note: this.note,
      executor: this.executor
    }
  }
}
